"use client";
import{createContext as r}from"react";const o=r({}),e=o.Provider,t=o.Consumer;export{t as TranslationConsumer,o as TranslationContext,e as TranslationProvider};
